import React from 'react';
import { SvgIconProps } from '@mui/material';

export const ForwardIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="33"
        height="25"
        viewBox="0 0 33 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M1 12.5L32 12.5L20.375 24M26.1875 6.75L20.375 1"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ForwardIcon;
